import { h, render, Component } from 'preact';

class Result extends Component {

	getResultTableHeadNode() {
		let stepHead = null
		if (this.props.steps > 1) {
			stepHead = <th>Schritt</th>;
		}
		return stepHead;
	}

	getResultTableNode() {
		let result =  this.props.result;
		let price = result.price;
		let resultTableBodyNode = null;

		if (this.props.steps > 1) {
			resultTableBodyNode = [];
			for( var i = 1; i <= this.props.steps; i++) {
				let calculatedPrice = price * i;
				calculatedPrice = Number(calculatedPrice).toLocaleString("de-DE", {style: "currency", currency: "EUR"});
				let node = <tr key={i}><td>Schritt {i}</td><td>{calculatedPrice}</td></tr>
				resultTableBodyNode.push(node)
			}
		} else {
			price = Number(price).toLocaleString("de-DE", {style: "currency", currency: "EUR"});
			resultTableBodyNode = <tr><td>{price}</td></tr>
		}
		return resultTableBodyNode;
	}

	getErrorMessage() {
		let errorMessage = '';

		if(this.props.error.errorMaxAge != null) {

			if (this.props.calculatorTypeUid != 4) {
				errorMessage = <p className="copy-text">Die Beiträge ab dem {this.props.maxAge}. Lebensjahr sind bei der Postbeamtenkrankenkasse hinterlegt.</p>;
			} else {
				errorMessage = <p className="copy-text">Eine Aufnahme in die {this.props.calculatorType} ist nur bis zur Vollendung des {this.props.maxAge}. Lebensjahres möglich.</p>;
			}
		}

		return errorMessage;
	}


	render() {
		let renderResult = true;
		let renderError = false;
		let errorMessage = '';
		let stepHead = null;
		let resultTableBodyNode = null;

		if (this.props.result == null) {
			renderResult = false;

			if(this.props.error != null) {
				renderError = true;
				errorMessage = this.getErrorMessage();
			}
		} else {
			stepHead = this.getResultTableHeadNode();
			resultTableBodyNode = this.getResultTableNode();
		}

		return (
			<div>
				{
					renderError ? (
						<div className="premium-calc__box premium-calc__box--notice">
							{errorMessage}
						</div>
					) :
						null
				}
				{
					renderResult ? (
						<div className="premium-calc__box premium-calc__box--results">
							{this.props.maxAge == this.props.entryAge && this.props.calculatorTypeUid == 4 ? (
								<p className="copy-text">Eine Aufnahme in die {this.props.calculatorType} ist nur bis zur Vollendung des {this.props.maxAge}. Lebensjahres möglich.</p>
							) : (
								<div className="copy-text">
									<h3 className="copy-h3" tabIndex="-1">Errechnete Beiträge für das Aufnahmealter {this.props.entryAge} Jahre</h3>
									<p className="copy-text">Unser Beitragsrechner stellt die Beiträge für Mitglieder und ihre mitversicherten Ehepartner bzw. eingetragenen Lebenspartner dar. Er errechnet nicht die Beiträge für die Versicherung von Kindern.</p>
								</div>
							)}
							<table className="copy-text-table">
								<thead>
									<tr>
										{stepHead}
										<th>monatlicher Beitrag</th>
									</tr>
								</thead>
								<tbody>
									{resultTableBodyNode}
								</tbody>
							</table>
						</div>
					) :
						null
				}
			</div>
		);
	}
}
export default Result;
